'use client';

import React from 'react';
import { useAuth } from "../../../contexts/AuthContext";
import { AuthGuard } from "../../auth/components/AuthGuard";
import { Header } from "../../landing/components/Header";
import { useNavigate, useParams } from 'react-router-dom';
import { EventForm } from '../components/EventForm';
import { Helmet } from 'react-helmet-async'

const EditEventPage: React.FC = () => {
  const { isLoading, isAuthenticated, isInitialized } = useAuth();
  const { eventId } = useParams<{ eventId: string }>();
  const navigate = useNavigate();
  // ...existing code...

  const handleEventSubmit = (eventId: string) => {
    // Redirigir a la página del evento con parámetro de éxito
    navigate(`/events/${eventId}?updated=true`);
  };

  const handleCancel = () => {
    navigate('/dashboard');
  };
  
  return (
    <>
    <Helmet>
      <title>Editar evento | Punta Tech Meetup</title>
      <meta name="description" content="Editá los detalles de tu evento para la comunidad de Punta Tech Meetup." />
    </Helmet>
    <AuthGuard
      requireAuth={true} 
      isLoading={isLoading} 
      isAuthenticated={isAuthenticated} 
      isInitialized={isInitialized}
    >
      <div className="min-h-screen overflow-x-hidden brand-gradient-surface">
        <Header theme='dark' onSignInClick={() => {}} />
        <div className="pt-20">
          <EventForm
            mode="edit"
            eventId={eventId ? eventId : ''}
            onSubmit={handleEventSubmit}
            onCancel={handleCancel}
          />
        </div>
      </div>
    </AuthGuard>
    </>
  );
};

export default EditEventPage;
